/* eslint-disable */
export default {
  dncAlert: 'Este contacto está en una lista No llamar.',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
